import React, { useState } from "react";

import ShipeeziNewGrid, { Column } from "Components/AppGrid/shipeezi-new-grid";
import BadgeSubStatus from "Components/Generic/BadgeSubStatus";
import { SubGridContainer } from "Components/Generic/Grid/styles";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Branch } from "Models/branch";
import { Member } from "Models/members/member";
import { Task } from "Models/task";
import { useTranslation } from "react-i18next";

interface TasksGridAfterRowProps {
  tasks: Task[];
  loading: boolean;
}
export const TasksGridAfterRow = ({ tasks, loading }: TasksGridAfterRowProps) => {
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(20);
  const { t: translate } = useTranslation();

  const handleCurrentPage = (numPage: number) => {
    setPage(numPage - 1);
  };

  const handlePageSize = (pageSize: number) => {
    setPageSize(pageSize);
  };

  const formatDate = (date: string) => {
    if (date) {
      return format(
        utcToZonedTime(date, Intl.DateTimeFormat().resolvedOptions().timeZone),
        "dd/MM/yyyy hh:mm a"
      );
    }

    return "-";
  };

  const getColumns = () => {
    const columns: Column[] = [
      {
        name: "branchFrom",
        hideSearch: true,
        title: translate("origin"),
        formatText: (branch: Branch) => branch?.name,
      },
      {
        name: "type",
        hideSearch: true,
        title: translate("taskType"),
      },
      {
        name: "leader",
        hideSearch: true,
        title: translate("leader"),
        formatComponent: (leader: Member, row: Task) =>
          row.memberLeader?.fullName || leader?.fullName || "",
      },
      {
        name: "startDate",
        title: translate("taskBooked"),
        hideSearch: true,
        formatComponent: formatDate,
      },
      {
        name: "updatedAt",
        title: translate("lastUpdated"),
        hideSearch: true,
        formatComponent: formatDate,
      },
      {
        name: "status",
        title: translate("status"),
        formatComponent: (status: string) => <BadgeSubStatus value={status} />,
        hideSearch: true,
      },
    ];

    return columns;
  };

  return (
    <SubGridContainer>
      <ShipeeziNewGrid
        loadingData={loading}
        data={tasks}
        onChangePageSize={handlePageSize}
        onNextPage={handleCurrentPage}
        onPreviousPage={handleCurrentPage}
        onGoToPage={handleCurrentPage}
        columns={getColumns()}
        totalItems={tasks?.length}
        pageSize={pageSize}
        pageSizeList={[20, 40, 60, 100]}
        currentPage={page}
        positionActionsColumn="right"
        showSelection={false}
        showHeaderGrid={false}
        showFooterGrid={false}
        showFooterPageInfo={false}
        showSort={false}
        showColumnChooser={false}
      />
    </SubGridContainer>
  );
};
